import { useThemeContext } from '#contexts/ThemeContext';
import { CallToAction } from '#models/outcome';
import { Product } from '#models/product';
import { Actions } from '#modules/Outcome/Product/components/Actions';
import { DetailText } from '#modules/Outcome/Product/components/DetailText';
import { ListFeature } from '#modules/Outcome/Product/components/ListFeature';
import { ProductImage } from '#modules/Outcome/Product/components/ProductImage';
import { ProductName } from '#modules/Outcome/Product/components/ProductName';
import { ScrollToTopOnMount } from '#modules/Outcome/Product/ScrollRestoration';
import { getImageOriginal, getThumbnailImage, getVideoOriginal } from '#utils/product';
import { Box, Grid, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBackIos } from '@material-ui/icons';
import React from 'react';

const BackButton = ({ handleBack }: { handleBack: any }) => {
  const { iconButtons } = useThemeContext();
  return (
    <Box
      position={{
        xs: 'relative',
        sm: 'absolute'
      }}
      top={{
        xs: 8,
        sm: 29
      }}
      left={{
        sm: -35
      }}
      marginLeft={{
        xs: 1.5,
        sm: 0
      }}
      marginBottom={{
        xs: 1,
        sm: 0
      }}
    >
      <IconButton onClick={handleBack}>
        <ArrowBackIos style={{ color: iconButtons }} fontSize='small' />
      </IconButton>
    </Box>
  );
};

interface ProductDetailProps {
  setProduct: (val: any) => void;
  product: Product;
  priceImpact?: number;
  discountValue?: number;
  callToActions?: CallToAction[];
  trackCTAs: (cta: CallToAction) => void;
}

const ProductDetail = ({
  product,
  setProduct,
  priceImpact = 0,
  discountValue = 0,
  callToActions = [],
  trackCTAs
}: ProductDetailProps) => {
  const imgUrl = getImageOriginal(product);
  const thumbnailImages = getThumbnailImage(product);
  const videoUrl = getVideoOriginal(product);
  const classes = useProductWrapper();
  const [primaryImage, setPrimaryImage] = React.useState<string>(imgUrl);

  return (
    <Box
      bgcolor='white'
      paddingBottom={10}
      px={{
        xs: 5
      }}
      position='relative'
      minHeight={'82vh'}
      height='100%'
      width='100%'
    >
      <ScrollToTopOnMount />
      <Grid container spacing={2} className={classes.productDetail}>
        <BackButton handleBack={() => setProduct(null)} />
        <Grid item xs={12} md={6}>
          <ProductImage imageUrl={primaryImage} thumbnailImages={thumbnailImages} setPrimaryImage={setPrimaryImage} />
        </Grid>
        <Grid item xs={12} md={6}>
          <ProductName name={product.name} />
          <Actions
            price={product.prices}
            callToActions={callToActions}
            priceImpact={priceImpact}
            discountValue={discountValue}
            videoUrl={videoUrl}
            trackCTAs={trackCTAs}
            product={product}
          />
          <DetailText description={product.description} />
          <ListFeature highlights={product.highlights} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProductDetail;

const useProductWrapper = makeStyles((theme?: any) => {
  return {
    productDetail: {
      position: 'relative',
      maxWidth: 830,
      margin: '0 auto',
      [theme.breakpoints.only('lg')]: {
        maxWidth: 796
      },
      [theme.breakpoints.only('md')]: {
        maxWidth: 620
      },
      [theme.breakpoints.only('sm')]: {
        maxWidth: 451
      },
      [theme.breakpoints.only('xs')]: {
        maxWidth: 336
      }
    }
  };
});
